module.exports = __webpack_public_path__ + "img/zc.145d8896.svg";